import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
    state: {
        token: null,
        invalidToken: true,
        assetsUrl: process.env.VUE_APP_API_ASSETS_URL
    },
    mutations: {
        SET_TOKEN(state, token) {
            state.token = token;
        },
        SET_TOKEN_INVALID(state) {
            state.invalidToken = true;
        },
        SET_TOKEN_VALID(state) {
            state.invalidToken = false;
        }
    },
    getters: {
        getToken: state => state.token,
        checkTokenValidity: state => !state.invalidToken,
        assetsUrl: state => state.assetsUrl
    }
});
